module.exports = __webpack_public_path__ + "img/other_oppo4.2191036c.jpg";